<template>
  <div>
    <strong>Backup tasks</strong>
    <br/><br/>
    <a @click="open_orders_backup_sync()" class="button is-warning"><span class="icon"><i class="fa fa-shopping-cart"></i></span><span>Backup Sync Orders</span></a>
    <a @click="open_products_backup_sync()" class="button is-warning"><span class="icon"><i class="fa fa-tag"></i></span><span>Backup Sync Products</span></a>
  </div>
</template>

<script>
import auth from '../auth'
import SyncModal from './SyncModal'
import axios from 'axios'
import * as $ from 'jquery'

export default {
  name: 'BackupTasks',
  data () {
    return {
    }
  },
  components: {
    SyncModal
  },
  methods: {
    sync_order (numberOfDays) {
      axios.post('/api/run_backup_orders', {
        days: numberOfDays
      })
        .then(response => {
          $('.modal').removeClass('is-active')
          this.$root.open_message_modal('Backup scheduled with task ID: ' + response.data.task_id)
        })
    },
    sync_product (numberOfDays) {
      axios.post('/api/run_backup_products', {
        days: numberOfDays
      })
        .then(response => {
          $('.modal').removeClass('is-active')
          this.$root.open_message_modal('Backup scheduled with task ID: ' + response.data.task_id)
        })
    },
    open_orders_backup_sync () {
      this.open_sync_modal(this.sync_order)
    },
    open_products_backup_sync () {
      this.open_sync_modal(this.sync_product)
    },
    open_sync_modal (callback) {
      this.$buefy.modal.open({
        parent: this,
        component: SyncModal,
        hasModalCard: true,
        props: {
          callback
        }
      })
    }
  },
  created () {
    auth.checkAuth(['trigger_backups'])
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
